<template>
  <div class="home-container">
    <van-nav-bar class="nav-bar">
      <template #left>
        <span class="appname">{{ siteName }}</span>
      </template>
      <template #right>
        <span class="appname loc" @click="onAddr">
          <van-icon name="location-o" size="20" color="#c9a84c" />
          {{ $t("nHome.checked_address") }}
        </span>
      </template>
    </van-nav-bar>

    <div class="home-scroll">
      <div class="banner" v-if="banners.length">
        <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v, key) in banners" :key="key">
            <img
              class="banner_img"
              :src="bannerSrc(v)"
              :alt="v.name || 'banner'"
            />
          </swiper-slide>
        </swiper>
      </div>

      <div class="noticeContent">
        <div class="sm">
          <div>
            <div class="left">
              <p>{{ $t("zise.meiti") }}</p>
              <p>{{ $t("zise.home_txt1") }}</p>
              <p>{{ $t("zise.home_txt2") }}</p>
            </div>
            <div class="right">
              <p>{{ $t("zise.ziyuan") }}</p>
            </div>
          </div>
          <span>{{ $t("zise.jiaru") }}</span>
          <div class="navs">
            <nav>
              <a :class="{ active: tabs === 0 }" @click="tabs = 0">{{
                $t("zise.neitiziyuan")
              }}</a>
              <a :class="{ active: tabs === 1 }" @click="tabs = 1">{{
                $t("zise.fuwutiaokuang")
              }}</a>
            </nav>
          </div>
        </div>
      </div>

      <div v-if="tabs === 1" class="item tiaokuan">
        <ul>
          <li>
            <div>
              <p>{{ $t("zise.pingtaiziyuan") }}</p>
              <span>{{ $t("zise.pingtaiziyuan1") }}</span>
            </div>
            <div>
              <p>{{ $t("zise.fuwufanwei") }}</p>
              <span>{{ $t("zise.fuwufanwei1") }}</span>
            </div>
          </li>
        </ul>
      </div>

      <van-pull-refresh
        v-if="tabs === 0"
        v-model="isLoading"
        :pulling-text="$t('refresh.pulling')"
        :loosing-text="$t('refresh.loosing')"
        :loading-text="$t('refresh.loading')"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :offset="50"
          :immediate-check="false"
          :finished-text="$t('video.no_more')"
          :loading-text="$t('refresh.loading')"
          @load="onLoad"
        >
          <div class="item">
            <ul>
              <li
                v-for="(a, i) in movielist"
                :key="i"
                @click="toDetail(a.id)"
              >
                <i>{{ $t("zise.yiyanzheng") }}</i>
                <div class="left">
                  <p>ID:{{ a.id }}**</p>
                  <div class="ziliao">
                    <span
                      >{{ $t("zise.nichen") }}：{{ a.xuanfei_name }}</span
                    >
                    <span
                      >{{ $t("zise.leixing") }}：{{ a.service || "" }}</span
                    >
                    <span
                      >{{ $t("zise.dizhi") }}：{{ a.address || "-" }}</span
                    >
                    <span
                      >{{ $t("zise.fuwuxiangmu") }}：{{
                        a.service || $t("zise.jihuoxianshi")
                      }}</span
                    >
                  </div>
                  <div class="ft">
                    <span class="stat">
                      <img class="ft-ico" src="/img/home/icon_like.png" alt="" />
                      {{ formatCount(a.dianzan) }}
                    </span>
                    <span class="stat">
                      <img class="ft-ico" src="/img/home/icon_view.png" alt="" />
                      {{ formatCount(a.chakan) }}
                    </span>
                  </div>
                </div>
                <div class="right">
                  <div class="avatar">
                    <img :src="a.img_url" alt="" />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { resolveAssetUrl } from "../../http";
export default {
  data() {
    return {
      tabs: 0,
      page: 1,
      isLoading: false,
      loading: false,
      finished: false,
      movielist: [],
      banners: [],
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
    };
  },
  computed: {
    // 网站名称取后台 system/base 配置
    siteName() {
      const info = this.$store.getters.getBaseInfo || {};
      return info.name || "";
    },
  },
  created() {
    localStorage.setItem("lang", "kr");
    this.$i18n.locale = "kr";
    this.getBasicConfig();
    this.getxuanfeilist(true);
  },
  methods: {
    formatCount(n) {
      if (n === 0 || n === "0") return "0k";
      if (n == null || n === "") return "0k";
      const s = String(n).trim();
      // 目标站直接在数字后加 k
      return /k$/i.test(s) ? s : s + "k";
    },
    bannerSrc(v) {
      return resolveAssetUrl((v && (v.url || v.img || v.image)) || "");
    },
    normalizeBanners(list) {
      const arr = Array.isArray(list)
        ? list
        : list && typeof list === "object"
        ? Object.keys(list).map((k) => list[k])
        : [];
      return arr
        .filter((b) => b && (b.url || b.img || b.image))
        .map((b) => ({
          ...b,
          url: resolveAssetUrl(b.url || b.img || b.image),
        }));
    },
    onAddr() {
      this.$toast(this.$t("nHome.checked_address"));
    },
    async getBasicConfig() {
      const loadConfig = async () => {
        const res = await this.$http({
          method: "get",
          url: "sys_config",
          data: { lang: "kr" },
        });
        if (res && res.data) {
          const n = res.data.notice;
          if (n && n !== "Cangcode") this.notice = n;
          // 部署校验：新代码会带 cfg_ver
          if (res.data.cfg_ver) {
            console.log("[sys_config]", res.data.cfg_ver, res.data.cfg_lang);
          }
          return this.normalizeBanners(res.data.banners);
        }
        return [];
      };

      // 先同步服务端语言 cookie，再拉配置（否则后台已设 kr 的轮播也会被空 cookie 过滤掉）
      try {
        await this.$http({
          method: "get",
          url: "replaceLang",
          data: { lang: "kr" },
        });
      } catch (e) {
        /* ignore */
      }

      let banners = [];
      try {
        banners = await loadConfig();
      } catch (e) {
        /* ignore */
      }

      if (!banners.length) {
        for (const lang of ["ja", "zh", "en", "kr"]) {
          try {
            await this.$http({
              method: "get",
              url: "replaceLang",
              data: { lang },
            });
            banners = await loadConfig();
            if (banners.length) break;
          } catch (e) {
            /* ignore fallback lang error */
          }
        }
        try {
          await this.$http({
            method: "get",
            url: "replaceLang",
            data: { lang: "kr" },
          });
        } catch (e) {
          /* ignore restore lang error */
        }
      }
      this.banners = banners;

      this.$http({ method: "get", url: "base_info" }).then((res) => {
        if (res && res.code === 200 && res.data) {
          this.$store.commit("setBaseInfoValue", res.data);
        }
      });
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.getxuanfeilist(true);
    },
    onLoad() {
      this.page += 1;
      this.getxuanfeilist(false);
    },
    getxuanfeilist(reset) {
      this.loading = true;
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: this.page },
      })
        .then((res) => {
          const list = (res && res.data) || [];
          const mapped = (Array.isArray(list) ? list : []).map((item) => ({
            ...item,
            img_url: resolveAssetUrl(
              typeof item.img_url === "string"
                ? item.img_url
                : Array.isArray(item.img_url)
                ? item.img_url[0]
                : item.img
            ),
          }));
          if (reset) this.movielist = mapped;
          else this.movielist = this.movielist.concat(mapped);
          // 接口一次返回全部，加载完即结束，避免底部「没有更多」错位重复触发
          this.finished = true;
          this.loading = false;
          this.isLoading = false;
        })
        .catch(() => {
          this.loading = false;
          this.isLoading = false;
          this.finished = true;
        });
    },
    toDetail(id) {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$router.push("/Login");
        return;
      }
      this.$router.push({ path: "/detail", query: { id } });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000000;
  overflow: hidden;
}
.nav-bar {
  background: #000 !important;
  border-bottom: 1px solid rgba(201, 168, 76, 0.45);
}
.appname {
  font-size: 4.267vw;
  color: #c9a84c;
}
.loc {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.home-scroll {
  height: calc(100% - 13.333vw);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 14.667vw;
}
.banner {
  width: 100%;
  margin-top: 4%;
  min-height: 40vw;
}
.banner_swiper {
  height: 40vw;
  width: 100%;
}
.banner_swiper .swiper-slide {
  border-radius: 1.333vw;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 82.667vw;
  height: 40vw;
  overflow: hidden;
  background-color: #141414;
}
.banner_img {
  border-radius: 1.333vw;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.noticeContent {
  padding: 4vw;
}
.sm {
  width: 100%;
  min-height: 1rem;
  border-radius: 1.333vw;
  border: 1px solid rgba(201, 168, 76, 0.55);
  margin: 1.333vw 0;
  background: #141414;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.333vw;
  position: relative;
  overflow: hidden;
}
.sm > div {
  position: relative;
  z-index: 99;
  display: flex;
}
.sm .left {
  width: 32%;
  position: relative;
  z-index: 99;
}
.sm .left:before {
  content: "";
  position: absolute;
  width: 0.02rem;
  height: 100%;
  background: #f6d5a1;
  right: 0;
  top: 0;
}
.sm .left p {
  font-weight: 1000;
  background-image: -webkit-linear-gradient(top, #f8dbae, #edbd71);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 4.267vw;
  text-align: center;
  margin-top: 3vw;
}
.sm .right {
  flex: 1;
  padding-left: 1.333vw;
}
.sm .right p {
  color: #dadada;
  font-size: 3vw;
  line-height: 6.4vw;
}
.sm > span {
  color: #c8c8c8;
  font-size: 3vw;
  padding-top: 1.333vw;
  text-align: center;
  line-height: 5.067vw;
}
.navs > nav {
  padding-top: 2vw;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.navs > nav a {
  font-size: 3.2vw;
  padding: 1.333vw 2vw;
  border-radius: 6.667vw;
  margin-right: 1.867vw;
  background: transparent;
  border: 1px solid rgba(201, 168, 76, 0.55);
  color: #c9a84c;
  margin-bottom: 1.333vw;
}
.navs > nav a.active {
  background: #c9a84c;
  color: #000;
}
.item {
  padding: 0 4vw;
}
.item ul {
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.item ul::after {
  content: "";
  display: block;
  clear: both;
}
.item ul li {
  float: none;
  width: 100%;
  margin-top: 1.333vw;
  min-height: 1.867vw;
  background: #141414;
  position: relative;
  overflow: hidden;
  margin-bottom: 1.333vw;
  border-radius: 1.333vw;
  border: 1px solid rgba(201, 168, 76, 0.45);
  padding: 1.333vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}
.item ul li i {
  position: absolute;
  right: -2.333vw;
  top: 2.667vw;
  background: #ff6056;
  font-size: 2.133vw;
  padding: 0.533vw 2.667vw;
  font-style: normal;
  transform: rotate(45deg);
  color: #e7e7e7;
}
.item ul li .left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1;
}
.item ul li .left p {
  background: linear-gradient(90deg, #efcba7, #dcab76);
  color: #8d5825;
  display: inline-block;
  font-size: 3.2vw;
  font-weight: 600;
  padding: 1.2vw 2.4vw;
  border-radius: 1.333vw;
  margin-bottom: 1.333vw;
  margin-top: 2.133vw;
}
.item ul li .left .ziliao {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 3.733vw;
  margin-left: 1.333vw;
}
.item ul li .left .ziliao span {
  padding: 0.4vw 0;
  color: #e8e8e8;
}
.item ul li .left .ft {
  display: flex;
  gap: 4vw;
  margin-top: 1.333vw;
  margin-left: 1.333vw;
  align-items: center;
}
.item ul li .left .ft .stat {
  display: inline-flex;
  align-items: center;
  gap: 1vw;
  font-size: 3.2vw;
  color: #c9a84c;
}
.item ul li .left .ft .stat .ft-ico {
  width: 3.733vw;
  height: 3.733vw;
  object-fit: contain;
  flex-shrink: 0;
}
.item ul li .right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.item ul li .right .avatar {
  width: 28vw;
  height: 28vw;
  border-radius: 50%;
  border: 0.267vw solid #5c534b;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.item ul li .right .avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.item.tiaokuan ul li {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}
.item.tiaokuan ul li p {
  color: #e1be9c;
  background-image: -webkit-linear-gradient(top, #f8dbae, #edbd71);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 3.733vw;
  font-weight: 600;
  text-align: left;
  padding: 1.333vw 0;
}
.item.tiaokuan ul li span {
  font-size: 3vw;
  color: #fff;
}
::v-deep .van-list__finished-text {
  clear: both;
  display: block;
  width: 100%;
  text-align: center;
  padding: 3.2vw 0 6vw;
  color: #999;
  font-size: 3.2vw;
  writing-mode: horizontal-tb;
}
</style>
